<template>
  <v-select
    :model-value="modelValue || null"
    :items="selectItems"
    :placeholder="placeholder"
    item-title="title"
    item-value="value"
    variant="outlined"
    density="compact"
    rounded="lg"
    color="primary"
    menu-icon="$chevron-down"
    hide-details
    class="job-family-group-select text-body-1"
    :list-props="{ density: 'compact', nav: true }"
    :menu-props="{ contentClass: 'job-family-group-select-menu' }"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template #selection>
      <span v-if="modelValue">{{ selectedLabel }}</span>
    </template>
  </v-select>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: { type: String, default: null },
  groups: { type: Array, default: () => [] },
  placeholder: { type: String, default: 'Select Job Family Group' },
});

defineEmits(['update:modelValue']);

const selectItems = computed(() => (props.groups || [])
  .filter((group) => group?.ulid)
  .map((group) => ({
    title: group.name,
    value: group.ulid,
  })));

const selectedLabel = computed(() => (
  selectItems.value.find((item) => item.value === props.modelValue)?.title || ''
));
</script>

<style scoped lang="less">
.job-family-group-select {
  :deep(.v-field--variant-outlined) {
    color: @text-darkest;

    .v-field__append-inner .v-icon {
      color: @text-dark;
    }

    .v-select__selection--placeholder {
      color: @text-light;
      opacity: 1;
      font-size: 13px;
    }
  }
}
</style>

<style lang="less">
.job-family-group-select-menu {
  &.v-overlay__content > .v-list {
    box-shadow: none;
    border: 1px solid @stroke-default;
    border-radius: 4px;
    padding: 0;
    background-color: @bg-default;
  }

  .v-list-item {
    padding: 8px 12px;
  }

  .v-list-item-title {
    font-size: 13px;
    font-weight: 500;
    line-height: 150%;
    color: @text-dark;
  }
}
</style>
